var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconForegroundImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "34px",
    viewBox: "0 0 42 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Slice 1@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons8-gallery"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38,34 L10,34 C7.8,34 6,32.2 6,30 L6,10 C6,7.8 7.8,6 10,6 L38,6 C40.2,6 42,7.8 42,10 L42,30 C42,32.2 40.2,34 38,34 Z",
    id: "Shape",
    fill: "#0095D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,28 L4,28 C1.8,28 0,26.2 0,24 L0,4 C0,1.8 1.8,0 4,0 L32,0 C34.2,0 36,1.8 36,4 L36,24 C36,26.2 34.2,28 32,28 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,5 C25.3431458,5 24,6.34314575 24,8 C24,9.65685425 25.3431458,11 27,11 C28.6568542,11 30,9.65685425 30,8 C30,6.34314575 28.6568542,5 27,5 Z",
    id: "Shape",
    fill: "#3B3273"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#3B3273",
    points: "14 9.9 5 23 23 23"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#3B3273",
    points: "25 15.5 19 23 31 23"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconForegroundImage);
export default __webpack_public_path__ + "static/media/icon-foreground-image.39085e7005d859b403ee43c71d85bd76.svg";
export { ForwardRef as ReactComponent };